<template>
  <div>
    <router-view/>
    <FormBusiness 
      :showDialog="dialogBusiness" 
      :item="business" 
      @confirmed="onBusinessConfirmed" 
      @cancelled="onBusinessCancelled"
    />
    <FormProduct 
      :showDialog="dialogProduct" 
      :item="product" 
      @confirmed="onProductConfirmed" 
      @cancelled="onProductCancelled"
    />
    <v-dialog v-model="dialogProductDelete" max-width="500px">
      <v-card>
        <v-card-title class="headline">Bạn có chắc bạn muốn xóa mục này?</v-card-title>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="primary darken-1" text @click="closeProductDelete">Hủy bỏ</v-btn>
          <v-btn color="pink darken-1" text @click="deleteProductConfirm">Đồng ý</v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import FormBusiness from '@/views/admin/businesses/Form';
  import FormProduct from '@/views/admin/products/Form';
  import { mapState } from 'vuex';
  export default {
    components: {
      FormBusiness,
      FormProduct
    },
    data: () => ({
      selectedItem: null,
      busId: null,
      business: {},
      products: [],
      product: {},
      editedProductIndex: -1,
      dialogBusiness: false,
      dialogProduct: false,
      dialogProductDelete: false,
    }),
    computed: {
      ...mapState([
        'authMod'
      ])
    },
    mounted () {
      axios.get(`api/v1/users/${this.authMod.user.user.id}`)
        .then(response => {
          let user = response.data;
          this.busId = user.info.coso_id;
          if(this.busId) {
            this.getBusiness(this.busId);
            this.getProducts(this.busId);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    methods: {
      getBusiness(id){
        axios.get(`api/v1/businesses/${id}`)
          .then(response => {
            this.business = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getProducts(id){
        axios.get(`api/v1/products-bybuss/${id}`)
          .then(response => {
            this.products = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      // Business
      showDialogBusiness(){
        this.dialogBusiness=true;
      },
      onBusinessConfirmed(item) {
        this.dialogBusiness = false;
        this.getBusiness(this.business.id);
      },
      onBusinessCancelled () {
        this.dialogBusiness = false;
      },
      // Product
      showProductDialog(item=null){
        this.product = item||{};
        this.dialogProduct = true;
      },
      onProductConfirmed(item) {
        this.dialogProduct = false;
        this.getProducts(this.business.id);
      },
      onProductCancelled () {
        this.dialogProduct = false;
      },
      editProduct (item) {
        this.editedProductIndex = this.products.indexOf(item);
        this.product = Object.assign({}, item);
        this.dialogProduct = true;
      },
      close () {
        this.dialogProduct = false
        this.$nextTick(() => {
          this.product = Object.assign({}, this.product);
          this.editedProductIndex = -1;
        })
      },
      deleteProduct (item) {
        this.editedProductIndex = this.products.indexOf(item);
        this.product = Object.assign({}, item);
        this.dialogProductDelete = true;
      },
      deleteProductConfirm () {
        const app = this;
        axios.delete(`api/v1/products/${app.product.id}`)
          .then(function (resp) {
            app.products = app.products.filter(val => val.id !== app.product.id);
            app.closeProductDelete();
          }).catch(function (error) {
            console.log(error);
          });
      },
      closeProductDelete () {
        this.dialogProductDelete = false;
        this.$nextTick(() => {
          this.product = Object.assign({}, this.product);
          this.editedProductIndex = -1;
        })
      },
    }
  }
</script>